<template>
  <div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="emailTemplate"
      :class="{ show: emailTemplate }"
    >
      <div style="max-width: 845px" class="cstm-modal">
        <div class="header justify-between">
          <h4>{{ type }} Email Template</h4>
          <button @click.stop="emailTemplate = false" class="close-modal">
            &times;
          </button>
        </div>
        <div class="modal-content">
          <div class="light_blue_holder p-4">
            <div class="inline-flex items-center w-full py-2" v-if="!ext_email">
              <label style="min-width: 100px">Filter</label>
              <v-select
                class="bg_white w-full"
                v-model="filterModule"
                label="title"
                :options="filterList"
                @input="getRelatedRecords()"
              ></v-select>
            </div>
          </div>

          <div class="p-4 border_btm relative">
            <vs-input
              placeholder="Enter subject here"
              class="w-full py-2"
              v-model="emailSubject"
            />

            <div class="py-2">
              <editor
                v-model="emailBody"
                :api-key="tinyMceApi"
                :init="initTinyMce"
              />
            </div>

            <div class="flex flex-wrap justify-between items-center">
              <div>
                <div
                  style="cursor: pointer"
                  @click="dynamicList = !dynamicList"
                  class="rounded_holder filled_bg my-1 ml-2"
                  v-if="!ext_email"
                  v-click-outside="outsideDropdownDynamic"
                >
                  <span class="material-icons-outlined"
                    >integration_instructions</span
                  >
                  <span class="pl-1">Dynamic Fields</span>

                  <!-- dynamic fields tooltip -->
                  <div
                    v-if="filterModule != null"
                    class="cstm_shadow_tooltip dynamic_fields_tooltip"
                    :class="[dynamicList ? 'show' : '']"
                  >
                    <h4 class="border_btm pb-4 mb-4">
                      {{ filterModule.title }}
                    </h4>
                    <div class="flex flex-wrap">
                      <div
                        class="outer-field-cstm-badge"
                        style="padding: 0 5px"
                        :key="index"
                        v-for="(item, index) in fieldCodes"
                        @click.stop="abc"
                      >
                        <div class="field-cstm-badge">
                          <a @click="appendCodeToTemplate(item.field_code)">{{
                            item.field_description
                          }}</a>
                          <!-- <a class="info"
                            ><span class="material-icons">info</span></a
                          >
                          <p class="description">
                            {{ item.field_description }}
                          </p> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <vs-dropdown
                vs-trigger-click
                class="inline-flex items-center cursor-pointer"
               
              >
                <img src="@/assets/images/pen.svg" alt="" />
                <span style="color: #2282da; font-weight: 500" class="pl-1"
                  >Email Signature</span
                >
                <vs-dropdown-menu class="modal_dropdown_menu">
                  <vs-dropdown-item  v-for="(item,index) in signatureList" :key="index"> <a @click="appendCodeToTemplate(item.body)">{{item.title}}</a></vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
            </div>
          </div>

          <div class="text-right p-4">
            <vs-button
              type="border"
              class="mr-2"
              v-if="!template_details"
              @click="sendSaveEmail('Save')"
              >Save</vs-button
            >
            <vs-button
              type="border"
              class="mr-2"
              v-else
              @click="sendSaveEmail('Update')"
              >Update</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRelatedRecords,
  emailTemplateCreate,
  emailTemplateEdit,
  emailSignatureList
} from '@/api/email'
import vSelect from 'vue-select'
import Editor from '@tinymce/tinymce-vue'
import { shortCourseList } from '@/api/admission'

import { getClassListWithoutPagination } from '@/api/classes'
import { Lead_list } from '@/api/leads'

export default {
  components: {
    vSelect,
    Editor
  },
  props: {
    emailTemplate: {
      default: false
    },
    type: {
      default: ''
    },
    template_details: {
      default: null
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
  },
  mounted () {
    // this.fetchSignatureList()
    if (this.template_details) {
      this.emailSubject = this.template_details.subject
      this.emailBody = this.template_details.body
      this.filterModule = {
        id: this.template_details.platform_module_id,
        title: this.template_details.platform_module.module_name
      }
      this.getRelatedRecords()
    }
    
  },
  watch: {
    emailTemplate () {
      if (!this.emailTemplate) {
        this.closeModal()
      }
    }
  },
  data () {
    return {
      signatureList:[],
      emailBody: '',
      emailSubject: '',
      addCC: false,
      external_users: '',
      fieldCodes: [],
      sendEmailToUsers: [],
      teacher_ids: [],
      parentlist: [],
      student_ids: [],
      parents_ids: [],
      filterPayload: {
        course_id: [],
        class_id: [],
        crm_id: []
      },
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observerClass: new IntersectionObserver(this.loadMoreClass),
      observerCRM: new IntersectionObserver(this.loadMoreCRM),

      customer_id: localStorage.getItem('customer_id'),
      templateList: false,
      dynamicList: false,
      tinyMceApi: '',
      ext_email: false,
      filterModule: null,
      filterList: [
        {
          id: 3,
          title: 'Courses'
        },
        {
          id: 49,
          title: 'Classes'
        },
        {
          id: 1,
          title: 'CRM'
        }
      ],
      courseList: [],
      classList: [],
      crm_list: [],
      studentlist: [],
      teacherList: [],
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      class_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      crm_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor |           table alignleft aligncenter alignright alignjustify |           bullist numlist outdent indent | removeformat | help'
      },
      external_users_arr: [],
      external_users_cc: ''
    }
  },
  methods: {
    outsideDropdownDynamic () {
      this.dynamicList = false
    },
    async fetchSignatureList () {
      const {data} = await emailSignatureList(
        {},
        'email_signature',
        {},
        localStorage.getItem('customer_id'),
        1,
        20
      )
      this.signatureList = data.data.signs
      this.signatureList = data.data.signs.filter((x) => {
        if (x.is_default === 1) {
          this.appendCodeToTemplate(x.body)
        }
      })
    },
    appendCodeToTemplate (field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand('mceInsertContent', false, field_code)
      this.dynamicList = false
    },
    preventCommaKey (event) {
      const keyCode = event.keyCode ? event.keyCode : event.which
      if (keyCode === 44) {
        event.preventDefault()
      }
    },
    getCustomEmailObject (external_user, is_root_user) {
      external_user = external_user.split(',')
      for (let i = 0; i < external_user.length; i++) {
        if (external_user[i].trim() !== '') {
          this.external_users_arr.push({
            email: external_user[i].trim(),
            is_root_user
          })
        }
      }
    },
    async sendSaveEmail (save_or_update) {
      if (this.ext_email) {
        this.getCustomEmailObject(this.external_users, true)
      }

      //CC Recipients
      if (this.addCC) {
        if (this.ext_email) {
          this.getCustomEmailObject(this.external_users_cc, false)
        }
      }
      const emailPayload = {
        subject: this.emailSubject,
        body: this.emailBody,
        platform_module_id: this.filterModule ? this.filterModule.id : null
      }
      console.log(emailPayload)
      try {
        this.$vs.loading()
        // eslint-disable-next-line no-unused-vars
        if (save_or_update === 'Save') {
          await emailTemplateCreate(this.customer_id, emailPayload)
        } else {
          await emailTemplateEdit(
            this.customer_id,
            this.template_details.id,
            emailPayload
          )
        }

        this.$vs.notify({
          title: 'Success',
          text: `Email template ${
            save_or_update !== 'Save' ? 'updated' : 'created'
          } successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.clearComposeEmail()
        this.$emit('closeEmailTempalatePopup', true)
      } catch (error) {
        console.log(error)
        let errorText = error.data.errors
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        } else if (error.data.errors.subject) {
          if (
            error.data.errors.subject[0] ===
            'The subject may not be greater than 255 characters.'
          ) {
            errorText = error.data.errors.subject[0]
          } else {
            errorText = 'Subject is required'
          }
        }

        //If there is any error empty selected users and custom emails
        this.external_users_arr = []
        this.sendEmailToUsers = []

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    clearComposeEmail () {
      this.emailSubject = ''
      this.emailBody = ''
      this.filterModule = ''
      this.$emit('closeEmailTempalateNFetch', true)
    },
    async loadMoreCourses () {
      try {
        const payload = {}
        this.course_list_meta.current_page =
          this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload,
          this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCourse () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.loadCourse)
      }
    },
    onCloseCourse () {
      this.observerCourse.disconnect()
    },
    async fetchCourseList () {
      const payload = {}
      this.course_list_meta.current_page = 1
      const { data } = await shortCourseList(
        localStorage.getItem('customer_id'),
        payload,
        this.course_list_meta
      )
      this.courseList = data.data.course_list

      this.course_list_meta = data.data.meta
    },
    async fetchClassList () {
      const { data } = await getClassListWithoutPagination(
        this.customer_id,
        this.class_meta
      )

      this.classList = data.data.class_short_list.data
      this.class_meta = data.data.meta
      this.class_meta.page = data.data.meta.current_page
    },
    async onOpenClass () {
      if (this.class_meta.has_next) {
        await this.$nextTick()
        this.observerClass.observe(this.$refs.loadClass)
      }
    },
    onCloseClass () {
      this.observerClass.disconnect()
    },
    async loadMoreClass () {
      try {
        this.class_meta.page = this.class_meta.page + 1

        const data = await getClassListWithoutPagination(
          this.customer_id,
          this.class_meta
        )
        this.classList.push(...data.data.data.class_short_list.data)
        this.class_meta = data.data.data.meta
        this.class_meta.page = data.data.data.meta.current_page
        console.log(this.classList)
      } catch (e) {
        //
      }
    },
    async fetchCrmList () {
      try {
        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list = data.data.results
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCRM () {
      if (this.crm_meta.has_next) {
        await this.$nextTick()
        this.observerCRM.observe(this.$refs.loadCRM)
      }
    },
    onCloseCRM () {
      this.observerCRM.disconnect()
    },
    async loadMoreCRM () {
      try {
        this.crm_meta.page = this.crm_meta.page + 1

        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list.push(...data.data.results)
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    closeModal () {
      this.$emit('closeEmailTempalatePopup', true)
    },
    async getRelatedRecords () {
      try {
        if (this.filterModule.id === 3) {
          this.fetchCourseList()
        } else if (this.filterModule.id === 49) {
          this.fetchClassList()
        } else if (this.filterModule.id === 1) {
          this.fetchCrmList()
        }
        const payload = {
          customer_id: this.customer_id,
          module_id: this.filterModule.id
        }

        this.selectedRelatedRecords = null
        const response = await getRelatedRecords(payload)
        this.fieldCodes = response.data.data.module_related_dynamic_field
      } catch (e) {
        console.log(e)
      }
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>